import axios from 'axios'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import brower from 'src/helper/brower'
import { isRussiaHost, isProduction } from 'src/helper/tool'
import { getlang } from 'src/helper/getlang'
// import sha1 from 'sha1'
// import sha256 from 'sha256'
axios.defaults.baseURL = isRussiaHost() && isProduction() ? config.hostRu || config.host : config.host
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(
  function (opt) {
    return opt
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response) {
    // console.log('请求成功',response)

    if (response.data && response.data.code !== 1) {
      return logicError(response.data)
    }
    return response.data
  },
  function (error) {
    console.log('请求失败')
    return error
    // return Promise.reject(error)
  }
)

function logicError(d) {
  // d.msg && message.error(d.msg)
  return d
}

async function httpMethod(method, url, data, dataExt, headers) {
  let map = {
    data: JSON.stringify(data),
    ...dataExt
  }
  const { accesstoken, uid } = localstorage.get('userInfo')
  // let UserDeviceInfo = localstorage.get('getUserDeviceInfo') || {}

  // let mac,
  //   version,
  //   deviceModel,
  //   systemVersion = ''
  // let UserDeviceInfo = {}

  // try {
  //   UserDeviceInfo = dsBridge.call('getUserDeviceInfo', '') || {}
  //   UserDeviceInfo = JSON.parse(UserDeviceInfo)
  //   // UserDeviceInfo = JSON.parse(UserDeviceInfo)
  // } catch (e) { }

  // if (UserDeviceInfo && UserDeviceInfo.mac) {
  //   mac = UserDeviceInfo.mac
  //   version = UserDeviceInfo.version
  //   deviceModel = UserDeviceInfo.deviceModel
  //   systemVersion = UserDeviceInfo.systemVersion
  // }
  // let { deviceModel, language, mac, os, platform, systemVersion, version, versionCode } = UserDeviceInfo
  let opt = { method, url }

  if (method === 'post') {
    headers = headers || { 'content-type': 'application/json' }
    headers['X-Mac'] = 'from-web'
    headers['X-Lang'] = await getlang()
    headers['X-Platform'] = brower.isAndroid() ? '2' : '1'
    headers['X-Ver'] = '502'
    // headers['X-Mobilephone'] = deviceModel || ''
    // headers['X-SysVersion'] = systemVersion || ''
    headers['X-Ts'] = parseInt(Date.parse(new Date()) / 1000)
    // headers['X-OsLang'] = navigator.language
    if (parseInt(uid) > 0) {
      headers['X-Uid'] = uid || 0
    }
    if (accesstoken && accesstoken != '') {
      headers['X-Token'] = accesstoken || ''
    }
    opt.headers = headers
  } else {
    if (headers) opt.headers = headers
  }

  // console.log(111)
  // console.log(opt)

  // if (headers) opt.headers = headers
  switch (method) {
    case 'get':
      opt.params = map
      break
    default:
      opt.data = map.data
      break
  }
  return axios(opt)
}

export default {
  request: axios.request,
  get(...args) {
    return httpMethod('get', ...args)
  },
  delete(...args) {
    return httpMethod('delete', ...args)
  },
  head: axios.head,
  post(...args) {
    // let d = httpMethod('post', ...args)
    // if (d && d.res && d.res == null) {
    //   d.res = []
    // }
    // return d
    return httpMethod('post', ...args)
  },
  put(...args) {
    return httpMethod('put', ...args)
  },
  patch(...args) {
    return httpMethod('patch', ...args)
  },
  postApp(url, map, callback, ltype) {
    // post请求  ltype=3  url请求网址  map请求参数  callback回调函数
    // app内部页面  ltype=1  url路由  map没有  没有回调函数
    if (brower.isIphone()) {
      try {
        if (ltype == 3) {
          url = url + '?json=' + JSON.stringify(map)
        }
        map = {
          ltype: ltype,
          link: url,
          body: JSON.stringify(map),
          callback: callback
          // "cbname": "cbdo"//已经没有用到js桥接回调
        }
        window.webkit.messageHandlers.jsbridgerequest.postMessage(map)
        return ''
      } catch (err) {
        return 'not in app'
      }
    } else {
      try {
        if (jsbridge && jsbridge.request != undefined) {
          jsbridge.request(ltype, url, JSON.stringify(map), callback)
          return ''
        } else {
          return 'not jsbridge'
        }
      } catch (err) {
        return 'not in app'
      }
    }
  }
}



// WEBPACK FOOTER //
// src/helper/http.js